var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disabled)?_c('div',[_vm._v(_vm._s(_vm.lang.get('entries.form.preview')))]):_c('a',{staticClass:"btn btn-tertiary btn-lg",attrs:{"href":_vm.route}},[_vm._v("\n  "+_vm._s(_vm.lang.get('entries.form.preview'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }